import { ReactComponent as CameraSvg } from '../assets/svg/camera.svg';

const CapturePhoto = ({
  fileRef,
  handleCapture,
  handleClickCapture,
  border = true,
  label,
  children,
  id = Math.random().toString(),
  disabled = false,
}) => {
  return (
    <div>
      <input
        ref={fileRef}
        accept='image/*'
        id={id}
        type='file'
        onChange={handleCapture}
        onClick={handleClickCapture}
        className='hidden'
        disabled={disabled}
      />
      <label htmlFor={id}>
        {children ? (
          children
        ) : (
          <div
            className={`rounded-full flex justify-center items-center ${
              border && 'border'
            } ${label ? 'text-xs font-bold' : 'size-12'}`}
          >
            {label ? label : <CameraSvg />}
          </div>
        )}
      </label>
    </div>
  );
};

export default CapturePhoto;
